var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      ref: "profile_modal",
      attrs: {
        size: "xl",
        bodyClass: "p-0",
        "no-close-on-backdrop": true,
        "hide-header": true,
        dialogClass: _vm.dialog_class_draw,
      },
      scopedSlots: _vm._u([
        {
          key: "modal-header",
          fn: function ({ close }) {
            return [
              _c(
                "b-button",
                {
                  attrs: { size: "sm", variant: "outline-danger" },
                  on: {
                    click: function ($event) {
                      return close()
                    },
                  },
                },
                [_vm._v("\n\t\t\t\tClose Modal\n\t\t\t")]
              ),
            ]
          },
        },
        {
          key: "modal-footer",
          fn: function ({ close }) {
            return [
              _c("div", { staticClass: "modal-footer w-100" }, [
                _c(
                  "button",
                  {
                    staticClass:
                      "btn btn-secondary waves-effect waves-themed ml-5",
                    attrs: { type: "button" },
                    on: { click: _vm.close_modal },
                  },
                  [_vm._v("\n\t\t\t\t\tЗакрити\n\t\t\t\t")]
                ),
              ]),
            ]
          },
        },
      ]),
      model: {
        value: _vm.is_show_modal,
        callback: function ($$v) {
          _vm.is_show_modal = $$v
        },
        expression: "is_show_modal",
      },
    },
    [
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "panel mb-0 border-bottom-0 shadow-none",
          attrs: { id: "panel_users_list" },
        },
        [
          _c(
            "div",
            {
              staticClass:
                "panel-hdr border-faded border-top-0 border-right-0 border-left-0 shadow-0",
            },
            [
              _c("h2", [
                _c("span", { staticClass: "fw-300" }, [_vm._v("Акт")]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "panel-toolbar pr-3 pb-2 align-self-end" },
                [
                  _c(
                    "button",
                    {
                      staticClass:
                        "btn btn-panel bg-transparent fs-xl w-auto h-auto rounded-0 waves-effect waves-themed",
                      on: {
                        click: function ($event) {
                          return _vm.close()
                        },
                      },
                    },
                    [_c("i", { staticClass: "fal fa-times" })]
                  ),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          !_vm.is_load
            ? _c("div", { staticClass: "p-1" }, [
                _c(
                  "div",
                  { staticClass: "user_equipments" },
                  _vm._l(_vm.users, function (user) {
                    return _c("div", { staticClass: "user_equipment" }, [
                      _c("div", { staticClass: "row lst p-3" }, [
                        _c("div", { staticClass: "user_id col-1" }, [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t\t" +
                              _vm._s(user.user_id) +
                              "\n\t\t\t\t\t\t\t"
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "user_fio col-10" }, [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t\t" +
                              _vm._s(user.name) +
                              "\n\t\t\t\t\t\t\t"
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "user_adv col-1" }, [
                          _c("i", {
                            staticClass:
                              "fa fa-file-pdf make_pdf fs-xl color-primary-100 cursor-pointer",
                            attrs: { "aria-hidden": "true" },
                            on: {
                              click: function ($event) {
                                return _vm.make_pdf(user)
                              },
                            },
                          }),
                        ]),
                      ]),
                      _vm._v(" "),
                      user.hasOwnProperty("equipments")
                        ? _c(
                            "div",
                            { staticClass: "user_items p-3" },
                            _vm._l(user.equipments, function (equipment) {
                              return _c("div", { staticClass: "user_eq row" }, [
                                _c(
                                  "div",
                                  { staticClass: "inp col-1" },
                                  [
                                    _c("b-checkbox", {
                                      model: {
                                        value: equipment.is_selected,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            equipment,
                                            "is_selected",
                                            $$v
                                          )
                                        },
                                        expression: "equipment.is_selected",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "name col-9" }, [
                                  equipment.hasOwnProperty("equipment_type")
                                    ? _c("span", [
                                        _vm._v(
                                          "\n                                        " +
                                            _vm._s(
                                              equipment.equipment_type.title
                                            ) +
                                            "\n                                    "
                                        ),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("small", [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t\t\t" +
                                        _vm._s(equipment.description) +
                                        "\n\t\t\t\t\t\t\t\t\t"
                                    ),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "cost col-2" }, [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t\t" +
                                      _vm._s(equipment.price) +
                                      "\n\t\t\t\t\t\t\t\t"
                                  ),
                                ]),
                              ])
                            }),
                            0
                          )
                        : _vm._e(),
                    ])
                  }),
                  0
                ),
              ])
            : _vm._e(),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }